import { render } from "./PeripheralItem.vue?vue&type=template&id=288108a0&scoped=true&ts=true"
import script from "./PeripheralItem.vue?vue&type=script&lang=ts"
export * from "./PeripheralItem.vue?vue&type=script&lang=ts"

import "./PeripheralItem.vue?vue&type=style&index=0&id=288108a0&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288108a0"]])

export default __exports__